
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/cookies",
      function () {
        return require("private-next-pages/settings/cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/cookies"])
      });
    }
  